import { create } from 'zustand';
import api from '../lib/api';
import type { Activity } from '../types';

export interface SendEmailPayload { personId: string; to: string; cc?: string; bcc?: string; subject: string; body: string; }
type SendResult = { activity: Activity } | { needsAuth: true };

interface EmailState {
  isSending: boolean;
  sendEmail: (payload: SendEmailPayload) => Promise<SendResult>;
}

export const useEmailStore = create<EmailState>((set) => ({
  isSending: false,
  sendEmail: async (payload) => {
    set({ isSending: true });
    try {
      const { data } = await api.post('/api/gmail/send', payload);
      return { activity: data.activity as Activity };
    } catch (e: any) {
      if (e.response?.status === 409 && e.response?.data?.code === 'NEEDS_SEND_AUTH') return { needsAuth: true };
      throw e;
    } finally {
      set({ isSending: false });
    }
  },
}));
